module.exports = [
  '1199 SEIU National Benefit Fund',
  '6 Degrees Health Inc.',
  '90 Degree Benefits',
  'AARP',
  'ACA StandardHealth with Health Choice',
  'ACI EAP',
  'ACI Specialty Benefits',
  'ACI Specialty Benefits EAP',
  'ACS Benefit Services Inc.',
  'APWU',
  'ASAGEHA',
  'ASR Corporation',
  'Abri Healthplan',
  'Absolute Total Care',
  'Absolute Total Care South Carolina',
  'Access Behavioral Care',
  'Acentra EAP',
  'Adventist Health',
  'Advocate Health Partners (PHO)',
  'Aetna',
  'Aetna ASA PPO/Assurant Health',
  'Aetna Affordable Health Choices (SM) - SRC',
  'Aetna Better Health - PA Medicaid',
  'Aetna Better Health Ohio',
  'Aetna Better Health of Illinois Inc.',
  'Aetna Better Health of Kansas',
  'Aetna Better Health of Kentucky',
  'Aetna Better Health of Louisiana',
  'Aetna Better Health of Michigan',
  'Aetna Better Health of New Jersey',
  'Aetna Better Health of Oklahoma',
  'Aetna Better Health of Virginia',
  'Aetna Better Health of West Virginia',
  'Aetna EAP',
  'Aetna TX Medicaid & CHIP',
  'Aither Health',
  'Alameda Alliance for Health',
  'Alignment Health Plan',
  'All One EAP',
  'All Savers Insurance',
  'AllCare Health',
  'Allegiance Benefit Plan Management',
  'Alliance Coal Health Plan',
  'Alliance EAP',
  'Alliance Health Plan',
  'Alliant Health Plans of Georgia',
  'Allied Benefit Systems',
  'Allina Health Aetna',
  'Allstate',
  'Aloha Care',
  'Alternatives EAP',
  'AmFirst Insurance Company',
  'Amalgamated Life Insurance Co.',
  'Ambetter',
  'AmeriChoice MS - CHIP (UnitedHealthcare Community Plan)',
  'AmeriChoice NJ Medicaid NJ Family Care (UnitedHealthcare Community Plan)',
  'AmeriChoice NY Medicaid & Child Health Plus (UnitedHealthcare Community Plan)',
  'AmeriChoice of New Jersey Personal Care Plus',
  'AmeriChoice of New York Personal Care Plus',
  'AmeriHealth - New Jersey',
  'AmeriHealth Caritas Louisiana (Formerly known as LA Care)',
  'AmeriHealth Caritas New Hampshire',
  'AmeriHealth Caritas Next (Delaware)',
  'AmeriHealth Caritas Next (North Carolina)',
  'AmeriHealth Caritas North Carolina',
  'AmeriHealth Caritas Ohio Medicaid',
  'AmeriHealth Caritas Pennsylvania',
  'AmeriHealth Delaware',
  'AmeriHealth District of Columbia',
  'AmeriHealth HMO New Jersey and Delaware',
  'AmeriHealth Mercy Health Plan',
  'Ameriben Solutions',
  `America's Choice NMA`,
  'American Behavioral',
  'American Behavioral EAP',
  'American Healthcare Alliance',
  'American Specialty Health',
  'Americhoice Personal Care Plus PA (UnitedHealthcare Community Plan)',
  'Amerigroup',
  'Amerigroup/Wellpoint Arizona',
  'Anthem',
  'Anthem BCBS EAP',
  'Anthem Blue Cross',
  'Anthem Blue Cross Blue Shield',
  'Anthem Blue Cross EAP',
  'Anthem Blue Cross of California',
  'Anthem EAP',
  'Anthem Maine Health',
  'Anthem Medical Ohio Medicaid',
  'Anthem of Colorado',
  'Anthem of Nevada',
  'Arizona Medicaid (AHCCCS)',
  'Arizona Physicians IPA (APIPA) (UnitedHealthcare Arizona Physicians IPA)',
  'Aspire Health Plan',
  'Associates for Healthcare',
  'Assurant Health Self Funded',
  'Asuris NW Health',
  'Atrio Health Plans',
  'Aultcare',
  'Aurora EAP',
  'Automated Benefit Services (ABS)',
  'Avera EAP',
  'Avera Health Plans',
  'BCBS BlueCare Family Plan (Connecticut)',
  'BCBS EAP',
  'BCBS Excellus',
  'BCBS Rhode Island',
  'BCBS South Carolina Federal Employee Program',
  'BCBS Texas Medicaid Star Chip',
  'BCBS Western NY Medicaid',
  'BCBSMN Blue Plus Medicaid',
  'BHO EAP',
  'BHP-Unity',
  'BHS EAP',
  'BPA EAP',
  'BRMS',
  'Balance EAP',
  'Banner Aetna',
  'BayCare EAP',
  'Beacon EAP',
  'Beacon Health Options (Formerly ValueOptions)',
  'Beacon Health Strategies',
  'Behavioral Health Systems',
  'Benefit Trust Life Insurance Company',
  'Best Care EAP',
  'Bind Benefits, Inc.',
  'Blomquist Hale EAP',
  'Blue Advantage of Arkansas',
  'Blue Advantage of LA',
  'Blue Choice Medicaid',
  'Blue Choice of Rochester NY',
  'Blue Cross',
  'Blue Cross Blue Shield',
  'Blue Cross Blue Shield Federal Employee Program',
  'Blue Cross Blue Shield of Alabama',
  'Blue Cross Blue Shield of Arizona',
  'Blue Cross Blue Shield of Connecticut',
  'Blue Cross Blue Shield of Florida',
  'Blue Cross Blue Shield of Georgia',
  'Blue Cross Blue Shield of Illinois',
  'Blue Cross Blue Shield of Indiana',
  'Blue Cross Blue Shield of Kansas',
  'Blue Cross Blue Shield of Kansas City',
  'Blue Cross Blue Shield of Kentucky',
  'Blue Cross Blue Shield of Louisiana',
  'Blue Cross Blue Shield of Maryland',
  'Blue Cross Blue Shield of Massachusetts',
  'Blue Cross Blue Shield of Michigan',
  'Blue Cross Blue Shield of Minnesota',
  'Blue Cross Blue Shield of Mississippi',
  'Blue Cross Blue Shield of Montana',
  'Blue Cross Blue Shield of Nebraska',
  'Blue Cross Blue Shield of New Mexico',
  'Blue Cross Blue Shield of North Carolina',
  'Blue Cross Blue Shield of North Dakota',
  'Blue Cross Blue Shield of Ohio',
  'Blue Cross Blue Shield of Oklahoma',
  'Blue Cross Blue Shield of Oregon',
  'Blue Cross Blue Shield of Rhode Island',
  'Blue Cross Blue Shield of South Carolina',
  'Blue Cross Blue Shield of Tennessee',
  'Blue Cross Blue Shield of Texas',
  'Blue Cross Blue Shield of Vermont',
  'Blue Cross Blue Shield of Wyoming',
  'Blue Cross Community Centennial',
  'Blue Cross Community Solutions',
  'Blue Cross Medicare Advantage',
  'Blue Cross of Idaho',
  'Blue Shield',
  'Blue Shield of Alaska',
  'Blue Shield of California',
  'Blue Shield of California Promise Health Plan',
  'Blue Shield of Delaware',
  'Blue Shield of Georgia (State Health of GA)',
  'Blue Shield of Hawaii',
  'Blue Shield of Idaho (Per Provider Testing)',
  'Blue Shield of Iowa',
  'Blue Shield of Kansas',
  'Blue Shield of Kansas City',
  'Blue Shield of Maine',
  'Blue Shield of Michigan',
  'Blue Shield of Mississippi',
  'Blue Shield of Missouri',
  'Blue Shield of Montana',
  'Blue Shield of New Hampshire',
  'Blue Shield of New York (Empire)',
  'Blue Shield of Northeast NY',
  'Blue Shield of Oklahoma',
  'Blue Shield of Pennsylvania',
  'Blue Shield of South Dakota',
  'Blue Shield of Utah',
  'Blue Shield of Vermont',
  'Blue Shield of Virginia',
  'Blue Shield of West Virginia',
  'Blue Shield of Western New York',
  'Blue Shield of Wisconsin',
  'Blue Shield of Wyoming',
  'Boston Medical Center Healthnet',
  'Braven Health',
  'Bravo Health (Formerly known as Elder Health Inc.)',
  'Bridgespan',
  'Bridgeway',
  'Bright Health',
  'Buckeye Community Health',
  'Buckeye Ohio Medicaid',
  'CBA Blue',
  'CBHA Carolina Behavioral Health Alliance',
  'CBNHP Health Choices',
  'CBSA (Corporation Benefit Services of America)',
  'CCA EAP',
  'CDO Technologies',
  'CDPHP',
  'CHAMPVA',
  'CHAMPVA-HAC',
  'CHIPA - College Health IPA',
  'Cal-Optima Portal',
  'Canopy EAP',
  'Cap Management Systems',
  'CapRock HealthPlans',
  'Capital Blue Cross',
  'Capital District PHP',
  'Capital Health Plan',
  'Care 1st Health Plan of California',
  'CareBridge EAP',
  'CareFirst BCBS - DC National Capital Area',
  'CareOregon',
  'CarePlus',
  'CareSource',
  'CareSource Arkansas',
  'CareSource Ohio Medicaid',
  'CareSource West Virginia',
  'CareSource of Georgia',
  'CareSource of Kentucky',
  'CareSource of Michigan Medicaid',
  'Carelon EAP',
  'Carepartners of Connecticut',
  'Caresource of Indiana',
  'Carolina Care Plan (Part of Medical Mutual)',
  'Carolina Complete Health',
  'Cascade Centers EAP',
  'Cascade EAP',
  'Cascade Health Alliance',
  'CenCal Health',
  'Cenpatico Behavioral Health Georgia',
  'Cenpatico Behavioral Health Indiana',
  'Centerstone EAP',
  'Centivo',
  'Central California Alliance for Health',
  'Ceridian LifeWorks EAP',
  'Charles Nechtem EAP',
  `Children's Community Health Plan`,
  `Children's Community Health Plan Wisconsin`,
  'Chiropractic Care of Minnesota Inc.',
  'Christian Brothers Services',
  'Christian Care Ministries (Medishare)',
  'Christus Health Plan HIX',
  'Cigna',
  'Cigna Behavioral Health',
  'Cigna Behavioral Health EAP',
  'Cigna EAP',
  'Cigna Healthcare for Seniors - Arizona Medicare',
  'ClaimsBridge HPN',
  'Claremont EAP',
  'Clarian Health Plans',
  'Clover Health',
  'Coastline EAP',
  'Colorado Access',
  'Colorado Community Health Alliance',
  'ComPsych',
  'ComPsych EAP',
  'Common Ground Healthcare Cooperative',
  'Commonwealth Care Alliance',
  'Community Care Alliance',
  'Community Care BHO (For Dates of Service after October 1 2007)',
  'Community Care Health Plan of KS',
  'Community Care Managed Health Care Plans of Oklahoma',
  'Community Connect Medicaid',
  'Community EAP',
  'Community First Health Plan Inc.',
  'Community Health Plan of Washington',
  'Comprehensive EAP',
  'Concern EAP',
  'ConnectiCare',
  'Connections Inc. EAP',
  'Consociate Group',
  'Consolidated Health Plans',
  'Continental Benefits',
  'Contra Costa Health Plan',
  `Cook Children's Health Plan`,
  `Cook Children's Star Plan`,
  'CoreSource',
  'CoreSource of Illinois',
  'CoreSource of Little Rock',
  'CoreSource of North Carolina',
  'CorpCare EAP',
  'Corporate Benefits Service Inc. (NC)',
  'Corvel',
  'County Care',
  'Coventry HealthCare of Florida',
  'Cox Health Plan',
  'CuraLinc EAP',
  'CuraLinc Healthcare',
  'CuraLinc Healthcare EAP',
  'CuraLink EAP',
  'Curative',
  'Custome Design Benefits Inc.',
  'DEA EAP',
  'DH Cook',
  'Dean Health Plan',
  'Dean Health Plan by Medica',
  'Deer Oaks EAP',
  'Denver Health Medical Plan',
  'Denver Health Medical Plan Inc. (Cofinity)',
  'Denver Health and Hospital Authority',
  'Deseret Mutual',
  'Detego Health',
  'Devoted Health',
  'Diversified Group Brokerage',
  'Driscoll Childrens Health Plan',
  'E4 Health EAP',
  'EBMS (Employee Benefit Management Services Inc.)',
  'EDS Healthchoice',
  'EMI Health',
  'ENH Medical Group IPA',
  'ENI EAP',
  'ERC EAP',
  'ESI EAP',
  'Early Intervention Central Billing',
  'East Carolina Behavioral Health',
  'Educators Mutual (EMIA)',
  'El Paso First - CHIP',
  'Emblem Health',
  'Empathia EAP',
  'Empire Blue Cross Blue Shield',
  'Employee Benefit Services, Inc.',
  'Employer Driven Insurance Services (EDIS)',
  'Empower Arkansas',
  'Empower Healthcare Solutions',
  'Encore Health Network',
  'Enterprise Group Planning',
  'Enticare',
  'Espyr EAP',
  'Essence Healthcare',
  'Essential Health Partners',
  'Essential Health Partners IPA',
  'Evernorth EAP',
  'Evolutions Healthcare',
  'Exceedent',
  'Excellus',
  'Excellus BCBS Central NY',
  'Excellus BCBS Rochester area',
  'Excellus BCBS Utica/Watertown',
  'Expert Benefit Solutions',
  'FCHN EAP',
  'FCP Insurance',
  'FEI EAP',
  'FMH Benefit Services',
  'Fallon Community Health',
  'Family Medical Network',
  'Federal Employee Program (Connecticut)',
  'Federal Employee Program (Michigan)',
  'Fidelis (CenterCare)',
  'Fidelis Care',
  'First Carolina Care',
  'First Choice Health',
  'First Choice Health EAP',
  'First Choice Next',
  'First Health',
  'First Sun EAP',
  'FirstCare',
  'FirstCare Star Medicaid',
  'Florida Health Plan',
  'Florida Hospital Waterman',
  'Fox-Everett Inc.',
  'Freedom Claims Management',
  'Freedom Life Insurance Company',
  'Fringe Benefit Group',
  'FrontPath Health Coalition',
  'GEHA',
  'GEHA (Government Employees Health Association)',
  'Gateway Health Plan',
  'Geisinger Health Plan',
  'Global Care Inc.',
  'Golden Rule (UnitedHealthOne)',
  'Gravie Inc.',
  'Great Lakes Health Plan (UnitedHealthcare Community Plan)',
  'Greater Oregon Behavioral Health',
  'Group Health Cooperative of South Central Wisconsin Claims',
  'Group Health Incorporated (GHI) (New York)',
  'Group Health Insurance - DE',
  'Group Practice Affiliates',
  'Gunderson Lutheran Health Plan',
  'HAP Caresource Michigan Marketplace',
  'HAP | Health Alliance Plan of Michigan',
  'HCSC Insurance Services Company',
  'HFN Inc.',
  'HIP | Health Insurance Plan of New York',
  'HMC Healthworks aka Health Management Co.',
  'HMO Colorado',
  'HMSA EAP',
  'Halcyon Behavioral',
  'Harvard Pilgrim',
  'Hawaii Management Alliance Association (HMAA)',
  'Headspace EAP',
  'Health 2 Business',
  'Health Advocate EAP',
  'Health Advocates EAP',
  'Health Alliance Medical Plans of Illinois',
  'Health Choice Utah',
  'Health Choice of AZ',
  'Health First Colorado',
  'Health First Health Plans',
  'Health First-Tyler TX',
  'Health Net',
  'Health Net of California',
  'Health Net of Oregon',
  'Health New England',
  'Health Options of Florida (Blue Shield HMO)',
  'Health Payment Systems',
  'Health Plan of Nevada',
  'Health Plan of San Joaquin',
  'Health Plan of San Mateo',
  'Health Plan of the Upper Ohio Valley',
  'Health Plans Inc.',
  'HealthCare Highways Health Plan',
  'HealthCare Solutions Group',
  'HealthComp',
  'HealthEZ',
  'HealthLINK PPO',
  'HealthNow New York, Inc.',
  'HealthPartners',
  'HealthPartners of Minnesota',
  'HealthSpring HMO/HealthSpring Medicare+Choice',
  'HealthTeam Advantage',
  'Healthfirst',
  'Healthscope',
  'Healthsource GA (Cigna)',
  'Healthsource TN (Cigna)',
  'Healthy Blue',
  'Healthy Blue Missouri',
  'Healthy Blue North Carolina',
  'Hennepin Health',
  'Highmark',
  'Highmark - Key Family',
  'Highmark Blue Cross Blue Shield',
  'Highmark Blue Cross Blue Shield of Delaware (BCBSD)',
  'Highmark Blue Cross Blue Shield of Western New York',
  'Highmark Blue Shield',
  'Highmark Health Options West Virginia',
  'Highmark Senior Health Company',
  'Holista, LLC',
  'Hometown Health Plan Nevada',
  'Horizon Blue Cross Blue Shield of New Jersey',
  'Humana',
  'Humana EAP',
  'Humana EAP and Work-Life Services',
  'Humana Ohio Medicaid',
  'IBH EAP',
  'iCARE (Independent Care Health Plan)',
  'III-A EAP',
  'IMA of Lousiana Inc.',
  'IMCare',
  'IU Health Plan',
  'Idealcare',
  'Illinois Health Plan (IHP)',
  'Imagine Health',
  'Impact Solutions EAP',
  'Independence Blue Cross',
  'Independent Blue Cross of PA (Also known as Personal Choice PPO of Pennsylvania)',
  'Independent Health',
  'Indiana University',
  'Inland Empire Health Plan',
  'Inland Empire Health Plan (Covered California)',
  'Innovation Health',
  'Insurance Management Services (Amarillo, TX)',
  'Insurance Management Services of Texas',
  'Integra Group',
  'Integrated Behavioral Health EAP',
  'Interactive Medical Systems TrialCard',
  'Intercommunity Health Net',
  'Interface EAP',
  'Intermountain EAP',
  'Iowa Health Advantage',
  'John Hopkins Healthcare (EHP/PP)',
  'Johns Hopkins (USFHP)',
  'Johns Hopkins Advantage MD',
  'KGA EAP',
  'KPIC - Kaiser Permanente',
  'Kaiser Foundation Health Plan Colorado',
  'Kaiser Foundation Health Plan Mid-Atlantic',
  'Kaiser Foundation Health Plan Northwest',
  'Kaiser Foundation Health Plan PPO',
  'Kaiser Foundation Health Plan of Colorado',
  'Kaiser Foundation Health Plan of Georgia',
  'Kaiser Foundation Health Plan of Northern California',
  'Kaiser Foundation Health Plan of Southern California',
  'Kaiser Foundation Health Plan of Washington Options',
  'Kaiser Foundation Health Plan of the Mid-Atlantic',
  'Kaiser Foundation Health Plan of the NW',
  'Kaiser Permanente',
  'Kaiser Permanente Georgia',
  'Kaiser Permanente Hawaii',
  'KanCare',
  'Kelsey Seybold',
  'Kempton Group',
  'Kepro EAP',
  'Kern Health Systems',
  'Kern Legacy Health Plan',
  'Keystone First PA Community HealthChoices',
  'Keystone Health Plan East',
  'LA Care Health Plan',
  'LBA HealthPlans',
  'Liberty HealthShare',
  'Liberty Mutual',
  'Life Services EAP',
  'Life Solutions EAP',
  'LifeWorks EAP',
  'Lifeprint',
  'Lifewise A Premier Health Plan',
  'Lifewise Assurance Company',
  'Lifewise Health Plan of Washington A Premier Health Plan',
  'Limited Benefit Group Supplemental',
  'Lockard & Williams',
  'Loma Linda University Adventist',
  'Louisiana Healthcare Connections',
  'Loyal American Life (Medicare Supplement)',
  'Loyola Physician Partners',
  'Lucet EAP',
  'Lyra',
  'Lytle EAP',
  'M&S EAP',
  'MD Rogue Oregon Health Plan',
  'MDwise Health Indiana Plan',
  'MDwise Hoosier Healthwise',
  'MEDICA',
  'MEDPLUS',
  'MHN EAP',
  'MHNet Behavioral Health',
  'MINES and Associates',
  'MMM Multi Health',
  'MOE Funds',
  'MSA Care Guard',
  'MVP Health Plan of NY',
  'MVP Healthcare',
  'Magellan',
  'Magellan Behavioral Health',
  'MagnaCare',
  'Magnolia Health Plan',
  'Maine Community Health',
  'MaineCare',
  'Managed Care Services LLC',
  'Managed Care Services MCS Nevada',
  'Managed Health Networks (MHN)',
  'Managed Health Services Indiana',
  'Managed Health Services of Wisconsin',
  'Martins Point Health Care',
  'Martins Point Health Care USFHP/Generations Advantage',
  'Maryland Physicians Care MPC',
  'Maryland Public Behavioral Health System',
  'Mass Health (MA Medicaid)',
  'Massachusetts Mutual also known as Mass Mutual',
  'Matrix EAP',
  'Mazzitti & Sullivan EAP',
  'McLaren Health Plan',
  'McLaren Medicaid',
  'McLaughlin Young EAP',
  'MedCost',
  'MedCost Benefit Services',
  'MedStar DC',
  'Medi-Cal',
  'MediCal of California',
  'MediGold',
  'Medica EAP',
  'Medica Government Programs',
  'Medica Health Care Plan Inc.',
  'Medica Health Plan Solutions',
  'Medica portal | Medica Health Plans Portal',
  'Medicaid',
  'Medicaid - TX Premier Plan',
  'Medicaid of Alabama',
  'Medicaid of Alaska',
  'Medicaid of Arkansas',
  'Medicaid of Colorado',
  'Medicaid of Connecticut',
  'Medicaid of Delaware',
  'Medicaid of Florida',
  'Medicaid of GA',
  'Medicaid of Idaho',
  'Medicaid of Illinois',
  'Medicaid of Indiana',
  'Medicaid of Iowa',
  'Medicaid of Kansas',
  'Medicaid of Kentucky',
  'Medicaid of Maine',
  'Medicaid of Maryland',
  'Medicaid of Michigan',
  'Medicaid of Minnesota',
  'Medicaid of Mississippi',
  'Medicaid of Missouri',
  'Medicaid of Montana',
  'Medicaid of Nevada',
  'Medicaid of New Jersey',
  'Medicaid of New Mexico',
  'Medicaid of New York',
  'Medicaid of North Carolina',
  'Medicaid of North Dakota',
  'Medicaid of Ohio',
  'Medicaid of Oklahoma',
  'Medicaid of Oregon',
  'Medicaid of Pennsylvania',
  'Medicaid of South Carolina',
  'Medicaid of South Dakota',
  'Medicaid of Texas',
  'Medicaid of Utah',
  'Medicaid of Vermont',
  'Medicaid of Virginia',
  'Medicaid of Washington DC',
  'Medicaid of Washington State',
  'Medicaid of West Virginia',
  'Medicaid of Wisconsin',
  'Medicaid of Wyoming',
  'Medical Associates Health Plan',
  'Medical Benefits Mutual',
  'Medical Mutual',
  'Medicare',
  'Medicare Part B of Alabama',
  'Medicare Part B of Alaska',
  'Medicare Part B of American Samoa',
  'Medicare Part B of Arizona',
  'Medicare Part B of Arkansas',
  'Medicare Part B of Colorado',
  'Medicare Part B of Connecticut',
  'Medicare Part B of DC',
  'Medicare Part B of Delaware',
  'Medicare Part B of Eastern Missouri',
  'Medicare Part B of Florida',
  'Medicare Part B of Georgia',
  'Medicare Part B of Idaho',
  'Medicare Part B of Illinois',
  'Medicare Part B of Indiana',
  'Medicare Part B of Iowa',
  'Medicare Part B of Kansas',
  'Medicare Part B of Kentucky',
  'Medicare Part B of Louisiana',
  'Medicare Part B of Maine',
  'Medicare Part B of Maryland',
  'Medicare Part B of Massachusetts',
  'Medicare Part B of Michigan',
  'Medicare Part B of Minnesota',
  'Medicare Part B of Mississippi',
  'Medicare Part B of Montana',
  'Medicare Part B of Nebraska',
  'Medicare Part B of Nevada',
  'Medicare Part B of New Hampshire',
  'Medicare Part B of New Jersey',
  'Medicare Part B of New Mexico',
  'Medicare Part B of New York (Empire)',
  'Medicare Part B of North Carolina',
  'Medicare Part B of North Dakota',
  'Medicare Part B of Northern California',
  'Medicare Part B of Ohio',
  'Medicare Part B of Oklahoma',
  'Medicare Part B of Oregon',
  'Medicare Part B of Queens NY',
  'Medicare Part B of Rhode Island',
  'Medicare Part B of South Carolina',
  'Medicare Part B of South Dakota',
  'Medicare Part B of Southern California',
  'Medicare Part B of Tennessee',
  'Medicare Part B of Texas',
  'Medicare Part B of Upstate NY',
  'Medicare Part B of Utah',
  'Medicare Part B of Vermont',
  'Medicare Part B of Virginia',
  'Medicare Part B of Washington',
  'Medicare Part B of West Virginia',
  'Medicare Part B of Western Missouri',
  'Medicare Part B of Wisconsin',
  'Medicare Part B of Wyoming',
  'Medicare Railroad (MetraHealth Medicare)',
  'Medicare of Pennsylvania',
  'Medico',
  'Memorial Hermann Health Network',
  'Mental Health Consultants Inc.',
  'Mercy EAP',
  'Mercy Health Plan (AHCCCS)',
  'Mercy Health Plan of New Jersey',
  'Mercy Maricopa Integrated Care',
  'MercyCare of Wisconsin',
  'Meridian Health Plan',
  'Meridian Health Plan Illinois Complete',
  'Meridian Health Plan Michigan',
  'Meritain Health',
  'MetLife',
  'Metro Plus Health Plan',
  'Michigan Blue Care HMO',
  'Michigan Blue Cross Complete',
  'Michigan Medicare PlusBlue',
  'Mid-America Associates',
  'Midland Management/MFC',
  'Midlands Choice',
  'Midwest Health Partners',
  'Military OneSource EAP',
  'Minnesota Blue Cross Blue Shield CC Systems',
  'Mississippi Select Healthcare',
  'Missoula County Medical Benefits',
  'Modern Health EAP',
  'Modern Health Insurance',
  'Molina',
  'Molina Complete Care VA',
  'Molina Health Care of South Carolina',
  'Molina Healthcare',
  'Molina Healthcare Utah',
  'Molina Healthcare of California',
  'Molina Healthcare of Florida',
  'Molina Healthcare of Idaho',
  'Molina Healthcare of Illinois',
  'Molina Healthcare of Iowa',
  'Molina Healthcare of Michigan',
  'Molina Healthcare of Mississippi',
  'Molina Healthcare of Nebraska',
  'Molina Healthcare of Nevada',
  'Molina Healthcare of New Mexico',
  'Molina Healthcare of Ohio',
  'Molina Healthcare of Texas',
  'Molina Healthcare of Washington',
  'Moline Complete Care DSNP',
  'Morneau Shepell EAP',
  'Mountain Health CO-OP',
  'Mountain Medical Affiliates',
  'Mountain Strong EAP',
  'MultiPlan',
  'Multiplan Wisconsin Preferred Provider Network',
  'Municipal Health Benefits Fund',
  'Mutual of Omaha',
  'Mutual of Omaha EAP',
  'My Group EAP',
  'NCAS - Charlotte VA',
  'NDBH EAP',
  'NGS American Inc.',
  'NYSHIP',
  'National EAP',
  'Nationwide',
  'Neighborhood Health Plan of Rhode Island',
  'Neighborhood Plan (Boston, MA)',
  'Network Health Insurance Corp - Medicare',
  'Network Health Massachusetts',
  'Network Health Plan of Wisconsin Inc.',
  'New Avenues Inc.',
  'New Directions Behavioral Health',
  'New Directions Behavioral Health EAP',
  'New Hampshire Healthy Families',
  'New Mexico Health Connections',
  'New York Network Management',
  'NextBlue of North Dakota',
  'Nippon Life Insurance Company',
  'Northern Nevada Trust Funds',
  'Northwell Direct',
  'NuVantage EAP',
  'ODS Health Plan',
  'Ohana Health Plan',
  'Ohio PPO Connect',
  'OhioRISE - Aetna Better Health of Ohio',
  'OptiMed Health',
  'Optima EAP',
  'Optima Health Plan',
  'Optum',
  'Optum Behavioral Health EAP',
  'Optum Behavioral Health SLCO',
  'Optum EAP',
  'Optum Health - Physical Health',
  'Optum San Diego Public Sector',
  'Oscar',
  'Out of Network',
  'Out of Pocket',
  'Oxford',
  'Oxford Health Plans',
  'PA Capital Blue Cross',
  'PAS EAP',
  'PacificSource Community Solutions',
  'PacificSource Health Plans',
  'Pacificsource Medicare',
  'Pacificsource OHP',
  'Palmetto EAP',
  'Paramount Health',
  'Paramount Health Plan',
  'Parkland Community Health Plan',
  'Partners Behavioral Health',
  'Partnership Health Plan',
  'Passport Health Plan',
  'Peak Health',
  'Pekin Insurance',
  'Pennsylvania Keystone Health Plan East',
  'Peoples Health Network (Tenet)',
  'Perspectives EAP',
  'Philadelphia American Life Insurance Company',
  'Physicians Care Network (Rockford, IL)',
  'Physicians Health Plan',
  'Physicians Health Plan (PHP-SC)',
  'Physicians Health Plan of Michigan Medicare',
  'Physicians Health Plan of Northern Indiana',
  'Physicians Mutual Insurance Company',
  'Prairie States Enterprises Inc.',
  'Preferred Care Partners (Miami Florida)',
  'Preferred One',
  'Premera Blue Cross',
  'Presbyterian (NM)',
  'Presbyterian Health Plan',
  'Presbyterian Salud',
  'Presence ERC',
  'Prestige Health Choice',
  'Primary PhysicianCare Inc.',
  'Prime West Health Plan',
  'Priority Health',
  'Pro-Claim Plus Inc.',
  'Profile EAP',
  'Progressive',
  'Prominence Health Plan of Nevada',
  'ProviDRs Care Network',
  'Providence Behavioral Health',
  'Providence Choice Option',
  'Providence Health Assurance Medicaid',
  'Providence Preferred (PPO)',
  'Psychealth Care Management LLC',
  'QUEST EAP',
  'Qual Choice of Arkansas',
  'Quality Care Partners',
  'Quartz',
  'Quest Behavioral Health',
  'Quicktrip Corporation',
  'RBH EAP',
  'REALiving EAP',
  'Reach EAP',
  'Redirect Health',
  'Regal Medical Group',
  'Regence Blue Shield of Washington',
  'Reliant Behavioral Health EAP',
  'Reliant EAP',
  'Resources for Living EAP',
  'Right Care from Scott & White',
  'Riverside Health Inc.',
  'Rocky Mountain HMO',
  'Rocky Mountain Health Plan Grand Junction',
  'S & S Healthcare Strategies',
  'SC BCBS State Employee Health Plan',
  'SC FEP Blue Cross',
  'SCHC Total Care',
  'SEIU',
  'SISCO',
  'SKAI Blue Cross Blue Shield',
  'SW Service Administrators',
  'Sagamore Health Network Inc.',
  'Sage Technologies (Formerly CCMSI)',
  'Saint Marys Health Plan',
  'Samaritan Advantage',
  'Samaritan Choice Plan',
  'Samaritan Employer Group Plan',
  'Samaritan Health Plans',
  'Sample EAP',
  'Sana',
  'Sana Benefits',
  'Sand Creek EAP',
  'Sanford Health Plan',
  'Sanford Health Plan Medicare Advantage',
  'Sante Health Systems',
  'Sapphire EAP',
  'Scott & White Health Care',
  'Security Health Plan',
  'Sedgwick',
  'Select Health of South Carolina',
  'SelectHealth',
  'SelectHealth Inc. Intermountain Health',
  'Selman and Company',
  'Sentara Mental Health Professional',
  'Sharp Health Plan',
  'Sierra Health',
  'SilverSummit',
  'Smokey Mountain Center',
  'Snedeker Risk Management',
  'Solarte Health',
  'Solutions EAP',
  'South County Health Alliance',
  'Southeastern Indiana Health',
  'Southwest EAP',
  'Spring Health EAP',
  'St. Lukes Health Plan',
  'State Farm',
  'Student Resources',
  'SummaCare Health Plan',
  'Summit Community Care',
  'Sunshine State Health Plan',
  'Superior Health Plan of Texas',
  'Sutter Health EAP',
  'Sutter Health Plus',
  'TRICARE East',
  'Telus Health EAP',
  `Texas Children's Health Plan`,
  'The Alliance of Wisconsin',
  'The Care Network',
  'The Empire Plan',
  'The Hartford',
  'The Health Plan (Upper Ohio Valley)',
  'The Loomis Company',
  'The Village EAP',
  'Three Rivers Preferred',
  'Total Plan Concepts',
  'Travelers',
  'TriHealth EAP',
  'TriWest',
  'TriWest VA CCN Region 1',
  'TriWest VA CCN Region 5',
  'Triad EAP',
  'Tribado',
  'Tricare',
  'Tricare Overseas',
  'Tricare West',
  'Tricare for Life',
  'Triple S Incorporated',
  'Triwest Healthcare Alliance',
  'TrueCare Mississippi Medicaid',
  'Trusteed Plans Service Corporation',
  'Tufts',
  'Tufts Health Plan',
  'UBH EAP',
  'UC Davis Health',
  'UCS Cement Masons',
  'UCS PBS Oregon',
  'UCS SecureOne Preferred United Plans',
  'UCare',
  'UHC EAP',
  'UMC Health Plan',
  'UMR',
  'UMR (formerly UMR Onalaska)',
  'UMR (formerly UMR Wausau)',
  'UMWA Health & Retirement Funds',
  'UPMC Health Plan',
  'US Family Health Plan (USFHP)',
  'USPS EAP',
  'UT EAP',
  'Ucare of Minnesota',
  'Ulliance EAP',
  'Umpqua Health Alliance',
  'UniCare',
  'Unicare EAP',
  'Unified Group Services',
  'Unite Here Health - LV',
  'United American',
  'United American Insurance',
  'United Behavioral Health',
  'United Behavioral Health EAP',
  'United EAP',
  'United Healthcare',
  'United Healthcare EAP',
  'United Healthcare Ohio Medicaid',
  'United Healthcare Oxford',
  'UnitedHealthcare Community Plan Missouri',
  'Unity Health Insurance',
  'Univera Health Care Plan/ChoiceCare Buffalo',
  'Univera Traditional PPO',
  'University Family Care',
  'University Health Alliance',
  'University of Illinois',
  'University of Utah Health Plans',
  'Upper Peninsula Health Plan',
  'Uprise Health EAP',
  'Utah Public Employee Health Plan (PEHP)',
  'VA Fee Basis Programs',
  'Valley Health Plan',
  'ValueOptions/MBHP',
  'Varipro',
  'Ventura County Health Plan',
  'Veterans Affairs Community Care Network',
  'Virginia Premier Health Plan',
  'Vital Worklife EAP',
  'Vitori Health',
  'Viva Health Plan',
  'WPS Commercial',
  'WPS Health Insurance',
  'Washington EAP',
  'Washington State Premera Blue Cross',
  'WellMed',
  'WellSpan EAP',
  'Wellcare',
  'Wellcare HMO',
  'Wellcare of CT',
  'Wellspring EAP',
  'Wellsprings EAP',
  `Western Grower's Assurance Trust`,
  'Western Health Advantage',
  'Western Oregon Advanced Health',
  'Western Pennsylvania Electrical Employees Insurance Trust Fund',
  'Western Southern Financial Group',
  'Wisconsin Commercial',
  'Workplace Options EAP',
  'Workplace Solutions EAP',
  'Yamhill Community Care Organization (YCCO)',
  'Zing Health',
];
